import UnitSearchList from "components/common/dl_unit/UnitSearchList/UnitSearchList";
import { useParams } from "react-router-dom";
import styled from "styled-components";

export default function GroupUTypeUnits() {
  const { slug, uType } = useParams();

  if (!slug || !uType) {
    return <></>;
  }

  return (
    <Div>
      <UnitSearchList navigateToSearch />
    </Div>
  );
}

const Div = styled.div`
  display: flex;
  flex-direction: column;
`;
